import React from 'react';
import PropTypes from 'prop-types';
import { CMS } from '../../utils/CMS';
import { TrackingUtils, withPageContext } from '../../utils';

const RESIDENT_KEYS = {
    children: {
        body: 'residentDiscount.widget.pluskids.title',
    },
    default: {
        body: 'residentDiscount.firstinfo.body',
    },
};

const ResidentDiscountMessageMobile = ({ trackEvent, hasNonAdults, isResidentDiscountPaxType, regionsText }) => {
    const [isLoaded, setLoaded] = React.useState(false);
    const trackOnLoad = () => {
        trackEvent({
            action: TrackingUtils.ACTION.FLIGHTS,
            label: 'resident_discount_msg_onload',
        });
        setLoaded(true);
    };

    !isLoaded && trackOnLoad();

    const residentKeys = hasNonAdults && !isResidentDiscountPaxType
        ? RESIDENT_KEYS.children
        : RESIDENT_KEYS.default;

    return (
        <div className="odf-text-info odf-space-inner-m odf-msg-informative">
            <div className="odf-strong odf-space-inner-bottom-s">
                <span className="odf-icon odf-icon-information odf-icon-xl" />
                <span className="odf-space-inner-left-s">
                    <CMS id="residentDiscount.firstinfo.tittle" />
                </span>
            </div>
            <div className="odf-text-md">
                <CMS id={residentKeys.body} values={{ residentZone: regionsText }} dangerouslySetInnerHTML />
            </div>
        </div>
    );
};

ResidentDiscountMessageMobile.propTypes = {
    trackEvent: PropTypes.func.isRequired,
    hasNonAdults: PropTypes.bool.isRequired,
    isResidentDiscountPaxType: PropTypes.bool.isRequired,
    regionsText: PropTypes.string.isRequired,
};

const withContext = withPageContext(ResidentDiscountMessageMobile);
export { withContext as ResidentDiscountMessageMobile };
